export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6495.182ca09b.jpg";